import React from "react";
import { connect } from "react-redux";
import * as globalParamAction from "../actions/globalParamActions";

/**
 * Komponent reprezentujący kolekcję parametrów globalnych
 */
const List = ({ list, onSubmit }) => (
    <ul className="w3-ul w3-card-4">
        {list.map(item => (
            <ListItem key={item.id} item={item} onSubmit={onSubmit} />
        ))}
    </ul>
);

/**
 * Komponent pojedyńczego paraemtu globalnego
 */
class ListItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item
        };
    }

    /**
     * Obsługa zmiany inputa
     */
    handleInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        let item = { ...this.state.item, [name]: value, useDefaultValue: false };
        this.setState({ item });
    };

    /**
     * Obsluga zapisania zmian
     */
    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit(this.state.item);
    };

    /**
     * Obsluga przywrócenia wartości domyślnej
     */
    handleRevert = e => {
        e.preventDefault();
        let item = { ...this.state.item, 'value': this.props.item.defaultValue, useDefaultValue: true };
        this.setState({ item });
    };

    render() {

        //baza klasowa dla obiektu Input
        const inputClassName = 'w3-input w3-border w3-round';
        //baza klasowa dla przycisku zapisz
        const buttonSaveClassName = 'w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark';

        return (
            <li className="w3-row">
                <form>

                    <span className="w3-bar-item w3-quarter" title={this.props.item.keyHint}>{this.props.item.keyLabel}</span>

                    <span className="w3-bar-item w3-half">
                        <input className={`${inputClassName} ${this.props.item.value !== this.state.item.value ? 'flow-italic w3-border-pink' : ''}`} type="text"
                            name="value" value={this.state.item.value} onChange={this.handleInputChange} />
                    </span>

                    <span className="w3-bar-item w3-right"><button title="Zapisanie" className={`${buttonSaveClassName}`} onClick={this.handleSubmit}><i className="far fa-save" /></button></span>

                    <span className="w3-bar-item w3-right"><button title="Przywracanie wartości domyślnej" className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark" onClick={this.handleRevert}><i className="fas fa-arrow-circle-left" /></button></span>

                </form>
            </li>
        );
    }

}


/**
 * Widok globalnych parametrów
 * 
 * https://www.robinwieruch.de/react-list-component
 * 
 */
class GlobalParams extends React.Component {

    state = {
        //zawartosc modala (doda, edytuj, usun)
        modalContent: null,
        //czy dane do tabelki sie zaladowaly
        loading: true
    };

    componentDidMount() {
        this._isMounted = true;

        //ladowanie danych do tabelki
        this.props.onFetch(() => {
            //po pobraniu danych do tabelki zmieniamy stan na zaladowany jesli jeszcze komponent jest aktywny
            if (this._isMounted) {
                this.setState({ loading: false });
            }
        });

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleSubmit = globalParam => {
        //zapisanie zmian pojedynczego parametru  
        this.props.onUpdate(globalParam);
    };

    render() {
        return (
            <div>
                <List list={this.props.globalParamList} onSubmit={this.handleSubmit} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        globalParamList: state.globalParamReducer.globalParamList
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetch: callback => {
            dispatch(globalParamAction.fetchGlobalParams(callback));
        },
        onUpdate: globalParam => {
            dispatch(globalParamAction.updateGlobalParams(globalParam));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalParams);